import { BBAPISubError } from "../../carrier/api-sub-error";
import { ContainerItemAware } from "./containerItem-aware";

export class ContainerItem {

  /** The material. */
  containerItemAware: ContainerItemAware;

  /** The display barcode. */
  displayBarcode: string;
  displayPrintBarcode: string;
  /** The position column. */
  positionCol: number;

  /** The position row. */
  positionRow: number;

  /** The qc pos. */
  qcPos: number;

  /** The scan time. */
  scanTime: Date;

  //barcode: string;
  isInternal: boolean;
  hasDuplicate: boolean;
  qcType: string;
  containerItemError: BBAPISubError;
}